import { RouteModule } from '#/horizon/components/RouteModule';
import type { importedListingRoute } from '#/modules/listing/routing/listing.routes';
import type { ApiImportedVolopHit } from '#/modules/listing/volops/api/types/ApiImportedVolop';
import { getSearchAlgoliaDefaultConfig } from '#/modules/search/algolia/searchAlgoliaConfig';
import { searchAlgoliaVolopsIndex } from '#/modules/search/algolia/searchAlgoliaVolopsIndex';
import { NotFoundPageLoadable } from '#/pages/NotFound/NotFoundPageLoadable';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { algoliaGetObject } from '#/utils/algolia/algoliaGetObject';

import { ImportedListingPageContainerLoadable } from './ImportedListingPageContainerLoadable';

export async function loader({
  params: { volopId },
}: HorizonAppRouteLoaderArgs<typeof importedListingRoute>) {
  const [importedVolopHit] = await Promise.all([
    algoliaGetObject<ApiImportedVolopHit>({
      config: getSearchAlgoliaDefaultConfig(),
      index: searchAlgoliaVolopsIndex({
        sort: 'relevance',
      }),
      id: volopId,
      attributes: ['*'],
    }),
    ImportedListingPageContainerLoadable.load(),
  ]);

  return { importedVolopHit };
}

export default function ImportedListingHorizonRoute({
  loaderData: { importedVolopHit },
}: HorizonAppRouteComponentProps<typeof loader>) {
  if (!importedVolopHit) return <NotFoundPageLoadable />;

  return (
    <RouteModule title={importedVolopHit.name}>
      <ImportedListingPageContainerLoadable
        importedVolopHit={importedVolopHit}
      />
    </RouteModule>
  );
}
